/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Deep_P3Inputs */

const en_sorter_deep_p3 = /** @type {(inputs: Sorter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting is also not natural sort. The keys item2 and item10 are compared as text, so item10 lands before item2 because the character 1 precedes 2. There is no numeric awareness inside a key name. If you need numbered keys in numeric order, pad them with leading zeros at the source, or restructure the data as an array where position is explicit.`)
};

const ko_sorter_deep_p3 = /** @type {(inputs: Sorter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬은 자연 정렬도 아닙니다. item2와 item10은 텍스트로 비교되므로 문자 1이 2보다 앞이라 item10이 item2보다 먼저 놓입니다. 키 이름 안의 숫자를 인식하지 않습니다. 번호가 붙은 키를 숫자 순으로 두어야 한다면 원본에서 앞에 0을 채우거나, 위치가 명시적인 배열로 데이터를 재구성하세요.`)
};

const ja_sorter_deep_p3 = /** @type {(inputs: Sorter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えは自然順ソートでもありません。item2 と item10 はテキストとして比較されるため、文字 1 が 2 より前なので item10 が item2 より先に来ます。キー名の中の数値を認識しません。番号付きのキーを数値順に並べる必要があるなら、元データで先頭にゼロを詰めるか、位置が明示的な配列としてデータを組み直してください。`)
};

/**
* | output |
* | --- |
* | "Sorting is also not natural sort. The keys item2 and item10 are compared as text, so item10 lands before item2 because the character 1 precedes 2. There is n..." |
*
* @param {Sorter_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_deep_p3 = /** @type {((inputs?: Sorter_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_deep_p3(inputs)
	if (locale === "ko") return ko_sorter_deep_p3(inputs)
	return ja_sorter_deep_p3(inputs)
});